<script>
import FormInput from '@vvg/forum/js/mixins/formInput'

export default {
	name: "Textarea",
	mixins: [FormInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'rows': {
			type: Number,
			default: 4
		}
	}
}
</script>

<template>
	<div class="my-3" :class="[groupClasses, { 'has-error': hasError }]">
		<div>
            <textarea
	            v-bind="$attrs"
	            :id="renderedId"
	            :name="name"
	            :value="modelValue"
	            :rows="rows"
	            :placeholder="label"
	            :class="{ 'is-invalid': hasError }"
	            class="field-type-textarea form-control"
	            @input="changeModelValue"
            />
		</div>
		<small v-if="hasError" class="text-danger d-block mt-1">
			{{ form.errors[name] }}
		</small>
	</div>
</template>